// frontend/src/utils/imageUtils.js

const API_BASE = 'https://temis-oficial.eu-4.evennode.com/api';

/**
 * Redirige las URLs de escudos de BeSoccer a través del proxy del backend
 * para evitar bloqueos por referrer/CORS
 */
export const cleanShieldUrl = (url) => {
  if (!url) return '';
  // Limpiar parámetro v= problemático
  const clean = url.replace(/[&?]v=\d+/g, '').replace(/\?&/, '?');
  // Redirigir a través del proxy
  return `${API_BASE}/proxy/image?url=${encodeURIComponent(clean)}`;
};